import { Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import * as ClassicEnrollInWorkflowActionMetadataKeys from 'automation-ui-action-features/actions/classic-enroll-in-flow/ClassicEnrollInWorkflowActionMetadataKeys';
export default class ClassicEnrollInWorkflowActionMetadata extends Record({
  [ClassicEnrollInWorkflowActionMetadataKeys.ACTION_TYPE]: ActionTypes.CLASSIC_ENROLL_IN_WORKFLOW,
  [ClassicEnrollInWorkflowActionMetadataKeys.WORKFLOW_ID]: null
}, 'ClassicEnrollInWorkflowActionMetadata') {}